import { Link } from "react-router-dom";
import IconNavigation from "../iconNavigation/IconNavigation";
import React from "react";

// Define a type for the Hotspot
interface Hotspot {
  id: number;
  label: string;
  link: string;
  classes?: string; // classes is optional
}
// Now, explicitly type the props for the HotspotLink component
interface HotspotLinkProps {
  hotspot: Hotspot;
}
export const HotspotLink: React.FC<HotspotLinkProps> = React.memo(({ hotspot }) => (
  <Link key={hotspot.id} to={hotspot.link} className={`hotspot-dot ${hotspot.classes || ""}`}>
    <IconNavigation
      description={hotspot.label}
      open={false}
      link={hotspot.link}
      position="top" />
  </Link>
));
